import { render } from "./NcrmPrivacySettingsCard.vue?vue&type=template&id=26d847c0&scoped=true"
import script from "./NcrmPrivacySettingsCard.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacySettingsCard.vue?vue&type=script&lang=js"

import "./NcrmPrivacySettingsCard.vue?vue&type=style&index=0&id=26d847c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d847c0"]])

export default __exports__